import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetPackageWithoutDetails } from 'app/typings/packages';
import { apiRequest } from 'app/utils/request/api';

export const extranetPackagePath = '/extranet/:hotelId/packages' as const;

export function useGetHotelPackages(hotelId: number) {
  return useQuery({
    queryKey: [extranetPackagePath, { hotelId }],
    queryFn: () =>
      apiRequest({
        path: extranetPackagePath,
        params: { hotelId: hotelId.toString() },
      }) as Promise<{
        packages: ExtranetPackageWithoutDetails[];
      }>,
    staleTime: Infinity,
    enabled: !!hotelId,
    meta: { errorMessage: 'Error fetching hotel packages' },
    placeholderData: keepPreviousData,
  });
}
